import React from 'react'

const Store = (props) => {
    return (
        <tr>
            <td>{props.retailer.gln}</td>
            <td>{props.gln}</td>
            <td>{props.retailer.name}</td>
            <td>{props.street}</td>
            <td>{props.zipCode}</td>
            <td>{props.city}</td>
            <td>
                <button className="btn btn-danger" onClick={() => props.removeStoreFromModule(props.gln)}
                        title="Store aus Modul entfernen">Store aus Modul entfernen&nbsp;
                    <i className="fa fa-exclamation-triangle"></i>
                </button>
            </td>
        </tr>
    );
};

export default Store;



// WEBPACK FOOTER //
// ./src/admin/module/overview/Store.js